import { useEffect, useState } from "react";

export default function useDelayedFlag(delayMs = 3000) {
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setFlag(true), delayMs);
    return () => clearTimeout(id);
  }, [delayMs]);

  return flag;
}
